import { evaluateQantity } from '@/services/calculate'
import { formatValue } from '@/services/convert'
import _ from 'lodash'

export const strikeAnalysisCalculations = (params, key, style) => {
  params.data.isValidTakeoff =
    params.data.isValidTakeoff === undefined
      ? true
      : params.data.isValidTakeoff
  const rowStyle = { textAlign: 'center' }
  if (style) {
    rowStyle.textAlign = style
  }
  if (params.data && !params.data.isValidTakeoff) {
    Object.assign(rowStyle, { backgroundColor: '#ff9900' })
  }
  if (key === 'calculation') {
    if (params.data && params.data.calculation && params.data.formula) {
      const quantity = params.data.quantity ? params.data.quantity : 0
      if (
        evaluateQantity(params.data.formula) !==
        formatValue(Number(quantity), 0)
      ) {
        if (evaluateQantity(params.data.formula) < 0) {
          Object.assign(rowStyle, {
            textDecoration: 'line-through',
            color: '#cf5460',
          })
        } else {
          Object.assign(rowStyle, { textDecoration: 'line-through' })
        }
        return rowStyle
      } else {
        return rowStyle
      }
    } else {
      return rowStyle
    }
  } else {
    return rowStyle
  }
}

export const updateGridRecord = (gridOptions, record, rowData) => {
  const itemsToUpdate = []
  gridOptions.api.forEachNodeAfterFilterAndSort(function(rowNode, index) {
    if (record && record.id === rowNode.data.id) {
      rowNode.data = { ...rowData }
    }
    const data = rowNode.data
    itemsToUpdate.push(data)
  })
  return itemsToUpdate
}

export const updateMultipleGridRecord = (gridOptions, newData) => {
  const itemsToUpdate = []
  gridOptions.api.forEachNodeAfterFilterAndSort(function(rowNode, index) {
    const rowData = newData.find(i => i.id === rowNode.data.id)
    if (rowData) {
      rowNode.data = { ...rowData }
    }
    const data = rowNode.data
    itemsToUpdate.push(data)
  })
  return itemsToUpdate
}

export const addMultipleGridRecord = (newData, takeoffs) => {
  const itemsToAdd = []
  takeoffs.forEach(element => {
    const rowData = newData.find(i => i.id === element.id)
    if (!rowData) {
      itemsToAdd.push(element)
    }
  })
  return itemsToAdd
}

export const deleteMultipleGridRecord = (gridOptions, newData) => {
  const itemsToDelete = []
  gridOptions.api.forEachNodeAfterFilterAndSort(function(rowNode, index) {
    const rowData = newData.find(i => i.id === rowNode.data.id)
    if (rowData) {
      itemsToDelete.push(rowNode.data)
    }
  })
  return itemsToDelete
}

export const updateConditionFactorGridRecord = (gridOptions, request) => {
  const itemsToUpdate = []
  gridOptions.api.forEachNodeAfterFilterAndSort(function(rowNode, index) {
    if (!rowNode.data.isLocked) {
      rowNode.data.conditionFactorId = request.conditionFactorId
      rowNode.data.conditionFactor = request.ConditionFactorValue
    }
    const data = rowNode.data
    itemsToUpdate.push(data)
  })
  return itemsToUpdate
}

export const addGridRecord = rowData => {
  const itemsToAdd = []
  itemsToAdd.push(rowData)
  return itemsToAdd
}

export const filterTakeoff = (takeoff, searchText, limit) => {
  let count = 0
  let totalCount = 0
  const filterResult = []
  _.forEach(takeoff, function(data) {
    if (
      !data.takeoffGrouping.toLowerCase().includes(searchText.toLowerCase())
    ) {
      const takeoffs = [...data.takeoffs]
      data.takeoffs = []
      data.takeoffs = takeoffs.filter(i =>
        i.takeoff.toLowerCase().includes(searchText.toLowerCase()),
      )
    }
    count = count + data.takeoffs.length
    data.takeoffs = _.take(data.takeoffs, limit - totalCount)
    totalCount = totalCount + data.takeoffs.length
    if (data.takeoffs.length > 0) {
      filterResult.push({
        takeoffGrouping: data.takeoffGrouping,
        takeoffs: data.takeoffs,
      })
    }
    if (count > limit) {
      return false
    }
  })
  return {
    count: count,
    currentResult: filterResult,
  }
}

export const filterGrid = (takeoff, searchText, limit) => {
  let count = 0
  let totalCount = 0
  const filterResult = []
  const list = []
  takeoff.forEach(data => {
    if (
      !data.takeoffGrouping.toLowerCase().includes(searchText.toLowerCase())
    ) {
      const takeoffs = [...data.takeoffs]
      data.takeoffs = []
      data.takeoffs = takeoffs.filter(i =>
        i.takeoff.toLowerCase().includes(searchText.toLowerCase()),
      )
    }
    data.takeoffs.forEach((element, index) => {
      if (index === 0) {
        list.push({
          takeoff: `${data.takeoffGrouping} (${data.takeoffs.length})`,
          section: 'col-span',
          id: element.id,
          takeoffId: element.takeoffId,
          key: element.key,
          unitCost: element.unitCost,
          unit: element.unit,
          life: element.life,
          mUnitId: element.mUnitId,
          mBsuopId: element.mBsuopId,
          mAssetClassId: element.mAssetClassId,
          mContractDetailsId: element.mContractDetailsId,
          mCategoryCodeId: element.mCategoryCodeId,
          takeoffGroupingId: element.takeoffGroupingId,
          takeoffGrouping: element.takeoffGrouping,
          categoryCode: element.categoryCode,
          assetClass: element.assetClass,
          source: element.source,
        })
      }
      list.push({
        takeoff: element.takeoff,
        section: undefined,
        id: element.id,
        takeoffId: element.takeoffId,
        key: element.key,
        unitCost: element.unitCost,
        unit: element.unit,
        life: element.life,
        mUnitId: element.mUnitId,
        mBsuopId: element.mBsuopId,
        mAssetClassId: element.mAssetClassId,
        mContractDetailsId: element.mContractDetailsId,
        mCategoryCodeId: element.mCategoryCodeId,
        takeoffGroupingId: element.takeoffGroupingId,
        takeoffGrouping: element.takeoffGrouping,
        categoryCode: element.categoryCode,
        assetClass: element.assetClass,
        source: element.source,
      })
    })
    count = count + data.takeoffs.length
    data.takeoffs = _.take(data.takeoffs, limit - totalCount)
    totalCount = totalCount + data.takeoffs.length
    if (data.takeoffs.length > 0) {
      filterResult.push({
        takeoffGrouping: data.takeoffGrouping,
        takeoffs: data.takeoffs,
      })
    }
  })
  return {
    count: count,
    list: list,
    currentResult: filterResult,
  }
}

export const filterTakeoffGrid = (takeoff, searchText, limit) => {
  let count = 0
  let totalCount = 0
  const filterResult = []
  const list = []
  takeoff.forEach(data => {
    if (
      !data.takeoffGrouping.toLowerCase().includes(searchText.toLowerCase())
    ) {
      const takeoffs = [...data.takeoffs]
      data.takeoffs = []
      data.takeoffs = takeoffs.filter(i =>
        i.takeoff.toLowerCase().includes(searchText.toLowerCase()),
      )
    }
    data.takeoffs.forEach((element, index) => {
      if (index === 0) {
        list.push({
          takeoff: `${data.takeoffGrouping} (${data.takeoffs.length})`,
          section: 'col-span',
          id: element.id,
          key: element.key,
          unitCost: element.unitCost,
          unit: element.unit,
          life: element.life,
          unitId: element.unitId,
          contractId: element.contractId,
          categoryCodeId: element.categoryCodeId,
          takeoffGroupingId: element.takeoffGroupingId,
          takeoffGrouping: element.takeoffGrouping,
          categoryCode: element.categoryCode,
          source: element.source,
        })
      }
      list.push({
        id: element.id,
        section: undefined,
        takeoff: element.takeoff,
        key: element.key,
        unitCost: element.unitCost,
        unit: element.unit,
        life: element.life,
        unitId: element.unitId,
        contractId: element.contractId,
        categoryCodeId: element.categoryCodeId,
        takeoffGroupingId: element.takeoffGroupingId,
        takeoffGrouping: element.takeoffGrouping,
        categoryCode: element.categoryCode,
        source: element.source,
      })
    })
    count = count + data.takeoffs.length
    data.takeoffs = _.take(data.takeoffs, limit - totalCount)
    totalCount = totalCount + data.takeoffs.length
    if (data.takeoffs.length > 0) {
      filterResult.push({
        takeoffGrouping: data.takeoffGrouping,
        takeoffs: data.takeoffs,
      })
    }
  })
  return {
    count: count,
    list: list,
    currentResult: filterResult,
  }
}

export const updateRowStyle = (params, key, style) => {
  params.data.isValidTakeoff =
    params.data.isValidTakeoff === undefined
      ? true
      : params.data.isValidTakeoff
  const rowStyle = { textAlign: 'center' }
  if (style) {
    rowStyle.textAlign = style
  }
  switch (key) {
    case 'takeoff_Grouping':
    case 'takeoff':
      rowStyle.textAlign = 'left'
      break
  }
  if (params.data && !params.data.isValidTakeoff) {
    Object.assign(rowStyle, { backgroundColor: '#ff9900' })
  }
  if (key === 'calculation') {
    if (params.data && params.data.calculation && params.data.formula) {
      const quantity = params.data.quantity ? params.data.quantity : 0
      if (
        evaluateQantity(params.data.formula) !==
        formatValue(Number(quantity), 0)
      ) {
        if (evaluateQantity(params.data.formula) < 0) {
          Object.assign(rowStyle, {
            textDecoration: 'line-through',
            color: '#cf5460',
          })
        } else {
          Object.assign(rowStyle, { textDecoration: 'line-through' })
        }
        return rowStyle
      } else {
        return rowStyle
      }
    } else {
      return rowStyle
    }
  } else {
    return rowStyle
  }
}

export const updateAnalysisSheetRowStyle = (params, key, style) => {
  params.data.isValidTakeoff =
    params.data.isValidTakeoff === undefined
      ? true
      : params.data.isValidTakeoff
  const rowStyle = { textAlign: 'center' }
  if (style) {
    rowStyle.textAlign = style
  }
  switch (key) {
    case 'takeoff_Grouping':
    case 'takeoff':
      rowStyle.textAlign = 'left'
      break
  }
  if (params.data && !params.data.isValidTakeoff) {
    Object.assign(rowStyle, { backgroundColor: '#ff9900' })
  }
  if (key === 'calculation') {
    if (params.data && params.data.calculation && params.data.formula) {
      const quantity = params.data.quantity ? params.data.quantity : 0
      if (
        evaluateQantity(params.data.formula) !==
        formatValue(Number(quantity), 0)
      ) {
        if (evaluateQantity(params.data.formula) < 0) {
          Object.assign(rowStyle, {
            textDecoration: 'line-through',
            color: '#cf5460',
          })
        } else {
          Object.assign(rowStyle, { textDecoration: 'line-through' })
        }
        return rowStyle
      } else {
        return rowStyle
      }
    } else {
      return rowStyle
    }
  } else {
    return rowStyle
  }
}

export const updateLockRow = (params, key, style) => {
  params.data.isValidTakeoff =
    params.data.isValidTakeoff === undefined
      ? true
      : params.data.isValidTakeoff
  const rowStyle = { textAlign: 'center' }
  if (style) {
    rowStyle.textAlign = style
  }
  switch (key) {
    case 'takeoff_Grouping':
    case 'takeoff':
      rowStyle.textAlign = 'left'
      break
  }

  if (params.data && params.data.quantity > 0) {
    if (!params.data.isValidTakeoff) {
      Object.assign(rowStyle, { backgroundColor: '#ff9900' })
    }
    if (params.data.editedFields) {
      const edited = JSON.parse(params.data.editedFields)
      const findKey = _.find(edited, value => value === key)
      if (findKey) {
        Object.assign(rowStyle, {
          color: findKey === 'calculation' ? '#753b40' : '#ffffff',
          backgroundColor: '#cf5460',
        })
      }
    }
    if (key === 'calculation') {
      if (params.data && params.data.calculation && params.data.formula) {
        const quantity = params.data.quantity ? params.data.quantity : 0
        if (
          evaluateQantity(params.data.formula) !==
          formatValue(Number(quantity), 0)
        ) {
          if (evaluateQantity(params.data.formula) < 0) {
            Object.assign(rowStyle, {
              textDecoration: 'line-through',
              color: rowStyle.color ? rowStyle.color : '#cf5460',
            })
          } else {
            Object.assign(rowStyle, { textDecoration: 'line-through' })
          }
          return rowStyle
        } else {
          return rowStyle
        }
      } else {
        return rowStyle
      }
    } else {
      return rowStyle
    }
  } else if (key === 'calculation' && !params.data.quantity) {
    if (params.data && params.data.calculation && params.data.formula) {
      const quantity = params.data.quantity ? params.data.quantity : 0
      if (
        evaluateQantity(params.data.formula) !==
        formatValue(Number(quantity), 0)
      ) {
        if (evaluateQantity(params.data.formula) <= 0) {
          Object.assign(rowStyle, {
            textDecoration: 'line-through',
            color: rowStyle.color ? rowStyle.color : '#cf5460',
          })
        } else {
          Object.assign(rowStyle, { textDecoration: 'line-through' })
        }
        return rowStyle
      } else {
        return rowStyle
      }
    } else {
      return rowStyle
    }
  } else {
    return rowStyle
  }
}

export const projectlockedRow = (params, key, style) => {
  params.data.isValidTakeoff =
    params.data.isValidTakeoff === undefined
      ? true
      : params.data.isValidTakeoff
  let align = 'center'
  if (style) {
    align = style
  }
  switch (key) {
    case 'takeoff_Grouping':
    case 'takeoff':
      align = 'left'
      break
  }
  if (params.data && params.data.editedFields) {
    const edited = JSON.parse(params.data.editedFields)
    const findKey = _.find(edited, value => value === key)
    if (findKey && findKey !== 'avoidVariance') {
      return { color: 'white', backgroundColor: '#cf5460', textAlign: align }
    } else {
      if (key !== 'action' && params.data && !params.data.isValidTakeoff) {
        return { backgroundColor: '#ff9900', textAlign: align }
      }
    }
  } else if (
    params.data &&
    params.data.isManuallyAdded &&
    params.data.isValidTakeoff &&
    key !== 'action'
  ) {
    return { backgroundColor: '#ffff80', textAlign: align }
  } else if (key !== 'action' && params.data && !params.data.isValidTakeoff) {
    return { backgroundColor: '#ff9900', textAlign: align }
  }
  return { textAlign: align }
}

export const strikeProjectAnalysisCalculations = (params, key, style) => {
  params.data.isValidTakeoff =
    params.data.isValidTakeoff === undefined
      ? true
      : params.data.isValidTakeoff
  let align = 'center'
  if (style) {
    align = style
  }
  if (params.data && params.data.calculation && params.data.formula) {
    const quantity = params.data.quantity ? Number(params.data.quantity) : 0
    if (
      evaluateQantity(params.data.formula) !== formatValue(Number(quantity), 0)
    ) {
      if (params.data.editedFields) {
        const edited = JSON.parse(params.data.editedFields)
        const findKey = _.find(edited, value => value === key)
        if (!findKey) {
          if (evaluateQantity(params.data.formula) < 0) {
            return {
              textDecoration: 'line-through',
              textAlign: align,
              color: '#cf5460',
            }
          } else {
            return { textDecoration: 'line-through', textAlign: align }
          }
        } else {
          if (evaluateQantity(params.data.formula) < 0) {
            return {
              color: '#4a272b',
              backgroundColor: '#cf5460',
              textDecoration: 'line-through',
              textAlign: align,
            }
          } else {
            return {
              color: 'white',
              backgroundColor: '#cf5460',
              textDecoration: 'line-through',
              textAlign: align,
            }
          }
        }
      } else if (params.data.isManuallyAdded && params.data.isValidTakeoff) {
        if (evaluateQantity(params.data.formula) < 0) {
          return {
            textDecoration: 'line-through',
            backgroundColor: '#ffff80',
            textAlign: align,
            color: '#cf5460',
          }
        } else {
          return {
            textDecoration: 'line-through',
            backgroundColor: '#ffff80',
            textAlign: align,
          }
        }
      } else if (params.data.isManuallyAdded && !params.data.isValidTakeoff) {
        if (evaluateQantity(params.data.formula) < 0) {
          return {
            textDecoration: 'line-through',
            backgroundColor: '#ff9900',
            textAlign: align,
            color: '#cf5460',
          }
        } else {
          return {
            textDecoration: 'line-through',
            backgroundColor: '#ff9900',
            textAlign: align,
          }
        }
      } else {
        if (params.data && !params.data.isValidTakeoff) {
          if (evaluateQantity(params.data.formula) < 0) {
            return {
              textDecoration: 'line-through',
              backgroundColor: '#ff9900',
              textAlign: align,
              color: '#cf5460',
            }
          } else {
            return {
              textDecoration: 'line-through',
              backgroundColor: '#ff9900',
              textAlign: align,
            }
          }
        } else {
          if (evaluateQantity(params.data.formula) < 0) {
            return {
              textDecoration: 'line-through',
              textAlign: align,
              color: '#cf5460',
            }
          } else {
            return { textDecoration: 'line-through', textAlign: align }
          }
        }
      }
    } else if (params.data && params.data.editedFields) {
      const edited = JSON.parse(params.data.editedFields)
      const findKey = _.find(edited, value => value === key)
      if (!findKey) {
        if (params.data && !params.data.isValidTakeoff) {
          return { backgroundColor: '#ff9900', textAlign: align }
        } else {
          return { backgroundColor: '#fff', textAlign: align }
        }
      } else {
        if (params.data && !params.data.isValidTakeoff) {
          return { backgroundColor: '#ff9900', textAlign: align }
        } else {
          return {
            color: 'white',
            backgroundColor: '#cf5460',
            textAlign: align,
          }
        }
      }
    } else if (
      params.data &&
      params.data.isManuallyAdded &&
      params.data.isValidTakeoff
    ) {
      return { backgroundColor: '#ffff80', textAlign: align }
    } else if (
      params.data &&
      params.data.isManuallyAdded &&
      !params.data.isValidTakeoff
    ) {
      return { backgroundColor: '#ff9900', textAlign: align }
    } else if (params.data && !params.data.isValidTakeoff) {
      return { backgroundColor: '#ff9900', textAlign: align }
    }
    return { textAlign: align }
  } else if (params.data && params.data.editedFields) {
    const edited = JSON.parse(params.data.editedFields)
    const findKey = _.find(edited, value => value === key)
    if (!findKey) {
      if (params.data && !params.data.isValidTakeoff) {
        return { backgroundColor: '#ff9900', textAlign: align }
      }
      return { backgroundColor: '#fff', textAlign: align }
    } else {
      return { color: 'white', backgroundColor: '#cf5460', textAlign: align }
    }
  } else if (
    params.data &&
    params.data.isManuallyAdded &&
    params.data.isValidTakeoff
  ) {
    return { backgroundColor: '#ffff80', textAlign: align }
  } else if (
    params.data &&
    params.data.isManuallyAdded &&
    !params.data.isValidTakeoff
  ) {
    return { backgroundColor: '#ff9900', textAlign: align }
  } else if (params.data && !params.data.isValidTakeoff) {
    return { backgroundColor: '#ff9900', textAlign: align }
  }
}

export const highlightLinkRows = (params, style, linkTileId) => {
  params.data.isValidTakeoff =
    params.data.isValidTakeoff === undefined
      ? true
      : params.data.isValidTakeoff
  const rowStyle = { textAlign: 'right' }
  if (style) {
    rowStyle.textAlign = style
  }
  if (params.data && linkTileId && linkTileId === params.data.childTileId) {
    Object.assign(rowStyle, { backgroundColor: '#ffff80' })
  } else if (params.data && !params.data.isValidTakeoff) {
    Object.assign(rowStyle, { backgroundColor: '#ff9900' })
  }
  return rowStyle
}

export const createTreeData = (data, type, list) => {
  let treeData = []
  switch (type) {
    case 'Grouping Bank':
      treeData = groupingBankTree(data)
      break
    case 'Tenant Bank':
      treeData = tenantBankTree(data)
      break
    case 'Template':
      treeData = templateTree(data)
      break
    case 'Standard':
      treeData = standardTree(data, list)
      break
    case 'Estimate Group':
      treeData = estimateGroupTree(data, list)
      break
    default:
      break
  }

  return treeData
}

export const groupingBankTree = data => {
  const treeData = []
  const keys = []

  data.forEach((element, index) => {
    treeData.push({
      key: element.interiorGroupId,
      data: {
        description: element.interiorGroup,
      },
      children: [],
    })
    keys.push(element.interiorGroupId)
    if (element.contracts && element.contracts.length > 0) {
      element.contracts.forEach((contract, i) => {
        treeData[index]['children'].push({
          key: `${element.interiorGroupId} ~ ${contract.mContractId} ~ ${i}`,
          data: {
            description: `${contract.contract} - ${contract.contractName}`,
          },
          children: [],
        })
        keys.push(
          `${element.interiorGroupId} ~ ${contract.mContractId} ~ ${i}`,
        )
        if (contract.categoryCodes && contract.categoryCodes.length > 0) {
          contract.categoryCodes.forEach((category, j) => {
            treeData[index]['children'][i]['children'].push({
              key: `${element.interiorGroupId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId} ~ ${j}`,
              data: {
                description: `${category.categoryCode} - ${category.categoryCodeDescription}`,
              },
              children: [],
            })
            keys.push(
              `${element.interiorGroupId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId} ~ ${j}`,
            )
            if (category.takeoffs && category.takeoffs.length > 0) {
              treeData[index]['children'][i]['children'][j]['children'].push({
                key: `0## ~ ${element.interiorGroupId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId}`,
                data: {
                  type: 'header',
                  description: 'Takeoff Description',
                  quantity: 'Quantity',
                  unit: 'Unit',
                  unitCost: 'Unit Cost',
                },
              })
              keys.push(
                `0## ~ ${element.interiorGroupId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId}`,
              )
              category.takeoffs.forEach((takeoff, z) => {
                treeData[index]['children'][i]['children'][j]['children'].push({
                  key: `${element.interiorGroupId} ~ ${
                    contract.mContractId
                  } ~ ${category.mCategoryCodeId} ~ ${
                    takeoff.mTakeoffId
                  } ~ ${z} ~ ${JSON.stringify(takeoff)}`,
                  data: {
                    description: takeoff.takeoff,
                    quantity: takeoff.quantity,
                    unit: takeoff.unit,
                    unitCost: takeoff.unitCost,
                  },
                })
                keys.push(
                  `${element.interiorGroupId} ~ ${contract.mContractId} ~ ${
                    category.mCategoryCodeId
                  } ~ ${takeoff.mTakeoffId} ~ ${z} ~ ${JSON.stringify(takeoff)}`,
                )
              })
            }
          })
        }
      })
    }
  })

  return { treeData: treeData, keyCount: keys }
}

export const tenantBankTree = data => {
  const treeData = []
  const keys = []

  data.forEach((element, index) => {
    treeData.push({
      key: element.tenantBankId,
      data: {
        description: element.tenant,
      },
      children: [],
    })
    keys.push(element.tenantBankId)
    treeData[index]['children'].push({
      key: `${element.tenantBankId} ~ ${element.tenant}`,
      data: {
        type: 'header',
        description: 'Tenant',
      },
      children: [],
    })
    keys.push(`${element.tenantBankId} ~ ${element.tenant}`)
    if (element.contracts && element.contracts.length > 0) {
      element.contracts.forEach((contract, i) => {
        treeData[index]['children'][0]['children'].push({
          key: `${element.tenantBankId} ~ ${contract.mContractId} ~ ${i}`,
          data: {
            description: `${contract.contract} - ${contract.contractName}`,
          },
          children: [],
        })
        keys.push(`${element.tenantBankId} ~ ${contract.mContractId} ~ ${i}`)
        if (contract.categoryCodes && contract.categoryCodes.length > 0) {
          contract.categoryCodes.forEach((category, j) => {
            treeData[index]['children'][0]['children'][i]['children'].push({
              key: `${element.tenantBankId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId} ~ ${j}`,
              data: {
                description: `${category.categoryCode} - ${category.categoryCodeDescription}`,
              },
              children: [],
            })
            keys.push(
              `${element.tenantBankId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId} ~ ${j}`,
            )
            if (category.takeoffs && category.takeoffs.length > 0) {
              treeData[index]['children'][0]['children'][i]['children'][j][
                'children'
              ].push({
                key: `0## ~ ${element.tenantBankId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId}`,
                data: {
                  type: 'header',
                  description: 'Takeoff Description',
                  quantity: 'Quantity',
                  unit: 'Unit',
                  unitCost: 'Unit Cost',
                },
              })
              keys.push(
                `0## ~ ${element.tenantBankId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId}`,
              )
              category.takeoffs.forEach((takeoff, z) => {
                treeData[index]['children'][0]['children'][i]['children'][j][
                  'children'
                ].push({
                  key: `${element.tenantBankId} ~ ${contract.mContractId} ~ ${
                    category.mCategoryCodeId
                  } ~ ${takeoff.mTakeoffId} ~ ${z} ~ ${JSON.stringify(
                    takeoff,
                  )}`,
                  data: {
                    description: takeoff.takeoff,
                    quantity: takeoff.quantity,
                    unit: takeoff.unit,
                    unitCost: takeoff.unitCost,
                  },
                })
                keys.push(
                  `${element.tenantBankId} ~ ${contract.mContractId} ~ ${
                    category.mCategoryCodeId
                  } ~ ${takeoff.mTakeoffId} ~ ${z} ~ ${JSON.stringify(takeoff)}`,
                )
              })
            }
          })
        }
      })
    }

    if (element.groupingBanks && element.groupingBanks.length > 0) {
      element.groupingBanks.forEach((grouping, g) => {
        treeData[index]['children'].push({
          key: `${element.tenantBankId} ~ ${grouping.interiorGroupId} ~ ${g}`,
          data: {
            type: 'header',
            description: grouping.interiorGroup,
            quantity: undefined,
            unit: undefined,
            unitCost: undefined,
          },
          children: [],
        })
        keys.push(
          `${element.tenantBankId} ~ ${grouping.interiorGroupId} ~ ${g}`,
        )
        const groupingIndex = treeData[index].children.findIndex(
          i => i.data.description === grouping.interiorGroup,
        )
        if (grouping.contracts && grouping.contracts.length > 0) {
          grouping.contracts.forEach((contract, i) => {
            treeData[index]['children'][groupingIndex]['children'].push({
              key: `${element.tenantBankId} ~ ${grouping.interiorGroupId} ~ ${contract.mContractId} ~ ${i}`,
              data: {
                description: `${contract.contract} - ${contract.contractName}`,
                quantity: undefined,
                unit: undefined,
                unitCost: undefined,
              },
              children: [],
            })
            keys.push(
              `${element.tenantBankId} ~ ${grouping.interiorGroupId} ~ ${contract.mContractId} ~ ${i}`,
            )
            contract.categoryCodes.forEach((category, j) => {
              treeData[index]['children'][groupingIndex]['children'][i][
                'children'
              ].push({
                key: `${element.tenantBankId} ~ ${grouping.interiorGroupId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId} ~ ${j}`,
                data: {
                  description: `${category.categoryCode} - ${category.categoryCodeDescription}`,
                  quantity: undefined,
                  unit: undefined,
                  unitCost: undefined,
                },
                children: [],
              })
              keys.push(
                `${element.tenantBankId} ~ ${grouping.interiorGroupId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId} ~ ${j}`,
              )
              if (category.takeoffs && category.takeoffs.length > 0) {
                treeData[index]['children'][groupingIndex]['children'][i][
                  'children'
                ][j]['children'].push({
                  key: `0## ~ ${element.tenantBankId} ~ ${grouping.interiorGroupId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId}`,
                  data: {
                    type: 'header',
                    description: 'Takeoff Description',
                    quantity: 'Quantity',
                    unit: 'Unit',
                    unitCost: 'Unit Cost',
                  },
                })
                keys.push(
                  `0## ~ ${element.tenantBankId} ~ ${grouping.interiorGroupId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId}`,
                )
                category.takeoffs.forEach((takeoff, z) => {
                  treeData[index]['children'][groupingIndex]['children'][i][
                    'children'
                  ][j]['children'].push({
                    key: `${element.tenantBankId} ~ ${
                      grouping.interiorGroupId
                    } ~ ${contract.mContractId} ~ ${
                      category.mCategoryCodeId
                    } ~ ${takeoff.mTakeoffId} ~ ${z} ~ ${JSON.stringify(
                      takeoff,
                    )}`,
                    data: {
                      description: takeoff.takeoff,
                      quantity: takeoff.quantity,
                      unit: takeoff.unit,
                      unitCost: takeoff.unitCost,
                    },
                  })
                  keys.push(
                    `${element.tenantBankId} ~ ${grouping.interiorGroupId} ~ ${
                      contract.mContractId
                    } ~ ${category.mCategoryCodeId} ~ ${
                      takeoff.mTakeoffId
                    } ~ ${z} ~ ${JSON.stringify(takeoff)}`,
                  )
                })
              }
            })
          })
        }
      })
    }
  })

  return { treeData: treeData, keyCount: keys }
}

export const templateTree = data => {
  const treeData = []
  const keys = []

  data.forEach((element, index) => {
    treeData.push({
      key: element.templateId,
      data: {
        description: element.templateName,
      },
      children: [],
    })
    keys.push(element.templateId)
    if (element.contracts && element.contracts.length > 0) {
      element.contracts.forEach((contract, i) => {
        treeData[index]['children'].push({
          key: `${element.templateId} ~ ${contract.mContractId} ~ ${i}`,
          data: {
            description: `${contract.contract} - ${contract.contractName}`,
          },
          children: [],
        })
        keys.push(`${element.templateId} ~ ${contract.mContractId} ~ ${i}`)
        if (contract.categoryCodes && contract.categoryCodes.length > 0) {
          contract.categoryCodes.forEach((category, j) => {
            treeData[index]['children'][i]['children'].push({
              key: `${element.templateId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId} ~ ${j}`,
              data: {
                description: `${category.categoryCode} - ${category.categoryCodeDescription}`,
              },
              children: [],
            })
            keys.push(
              `${element.templateId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId} ~ ${j}`,
            )
            if (category.takeoffs && category.takeoffs.length > 0) {
              treeData[index]['children'][i]['children'][j]['children'].push({
                key: `0## ~ ${element.templateId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId}`,
                data: {
                  type: 'header',
                  description: 'Takeoff Description',
                  quantity: 'Quantity',
                  unit: 'Unit',
                  unitCost: 'Unit Cost',
                },
              })
              keys.push(
                `0## ~ ${element.templateId} ~ ${contract.mContractId} ~ ${category.mCategoryCodeId}`,
              )
              category.takeoffs.forEach((takeoff, z) => {
                treeData[index]['children'][i]['children'][j]['children'].push({
                  key: `${element.templateId} ~ ${contract.mContractId} ~ ${
                    category.mCategoryCodeId
                  } ~ ${takeoff.mTakeoffId} ~ ${z} ~ ${JSON.stringify(
                    takeoff,
                  )}`,
                  data: {
                    description: takeoff.takeoff,
                    quantity: takeoff.quantity,
                    unit: takeoff.unit,
                    unitCost: takeoff.unitCost,
                  },
                })
                keys.push(
                  `${element.templateId} ~ ${contract.mContractId} ~ ${
                    category.mCategoryCodeId
                  } ~ ${takeoff.mTakeoffId} ~ ${z} ~ ${JSON.stringify(takeoff)}`,
                )
              })
            }
          })
        }
      })
    }
  })

  return { treeData: treeData, keyCount: keys }
}

export const standardTree = (data, list) => {
  const treeData = []
  const keys = []
  const treeKeys = {}

  data.forEach((element, index) => {
    treeData.push({
      key: `${element.levelId} ~ ${element.mContractId}`,
      data: {
        description: `${element.contract} - ${element.contractName}`,
      },
      children: [],
    })
    keys.push({
      id: element.levelId,
      key: `${element.levelId} ~ ${element.mContractId}`,
    })
    if (element.categoryCodes && element.categoryCodes.length > 0) {
      element.categoryCodes = _.sortBy(element.categoryCodes, ['categoryCode'])
      element.categoryCodes.forEach((category, i) => {
        treeData[index]['children'].push({
          key: `${element.levelId} ~ ${element.mContractId} ~ ${category.mCategoryCodeId} ~ ${i}`,
          data: {
            description: `${category.categoryCode} - ${category.categoryCodeDescription}`,
          },
          children: [],
        })
        keys.push({
          id: element.levelId,
          key: `${element.levelId} ~ ${element.mContractId} ~ ${category.mCategoryCodeId} ~ ${i}`,
        })
        if (category.takeoffs && category.takeoffs.length > 0) {
          treeData[index]['children'][i]['children'].push({
            key: `0## ~ ${element.levelId} ~ ${element.mContractId} ~ ${category.mCategoryCodeId}`,
            data: {
              type: 'header',
              description: 'Cost Type',
              takeoff: 'Description',
              cost: 'Cost',
              tileName: 'Tile Name',
            },
          })
          keys.push({
            id: element.levelId,
            key: `0## ~ ${element.levelId} ~ ${element.mContractId} ~ ${category.mCategoryCodeId}`,
          })
          category.takeoffs.forEach((takeoff, j) => {
            treeData[index]['children'][i]['children'].push({
              key: `${element.levelId} ~ ${element.mContractId} ~ ${
                category.mCategoryCodeId
              } ~ ${takeoff.actualTakeoffId} ~ ${j} ~ ${JSON.stringify(
                takeoff,
              )}`,
              data: {
                description: takeoff.costType,
                takeoff: takeoff.takeoff,
                cost: takeoff.unitCost,
                tileName: takeoff.tileName,
              },
            })
            keys.push({
              id: element.levelId,
              key: `${element.levelId} ~ ${element.mContractId} ~ ${
                category.mCategoryCodeId
              } ~ ${takeoff.actualTakeoffId} ~ ${j} ~ ${JSON.stringify(
                takeoff,
              )}`,
            })
          })
        }
      })
    }
  })

  if (list && list.length > 0) {
    list.forEach(element => {
      const details = keys.filter(i => i.id === element.id)
      if (details.length > 0) {
        Object.assign(treeKeys, {
          [element.id]: details.length,
        })
      }
    })
  }

  return { treeData: treeData, keyCount: keys, treeKeys: treeKeys }
}

export const estimateGroupTree = (data, list) => {
  const treeData = []
  const keys = []
  const treeKeys = {}

  data.forEach((element, index) => {
    treeData.push({
      key: `${element.estimateGroupId} ~ ${element.mContractId}`,
      data: {
        description: `${element.contract} - ${element.contractName}`,
      },
      children: [],
    })
    keys.push({
      id: element.estimateGroupId,
      key: `${element.estimateGroupId} ~ ${element.mContractId}`,
    })
    if (element.categoryCodes && element.categoryCodes.length > 0) {
      element.categoryCodes = _.sortBy(element.categoryCodes, ['categoryCode'])
      element.categoryCodes.forEach((category, i) => {
        treeData[index]['children'].push({
          key: `${element.estimateGroupId} ~ ${element.mContractId} ~ ${category.mCategoryCodeId} ~ ${i}`,
          data: {
            description: `${category.categoryCode} - ${category.categoryCodeDescription}`,
          },
          children: [],
        })
        keys.push({
          id: element.estimateGroupId,
          key: `${element.estimateGroupId} ~ ${element.mContractId} ~ ${category.mCategoryCodeId} ~ ${i}`,
        })
        if (
          (category.costDetails && category.costDetails.length > 0) ||
          (category.lineItems && category.lineItems.length > 0)
        ) {
          if (element.estimateGroupId > 0) {
            treeData[index]['children'][i]['children'].push({
              key: `0## ~ ${element.estimateGroupId} ~ ${element.mContractId} ~ ${category.mCategoryCodeId}`,
              data: {
                type: 'header',
                description: 'Cost Type',
                takeoff: 'Description',
                cost: 'Cost',
                tileName: 'Tile/Estimate Group Name',
              },
            })
          } else {
            treeData[index]['children'][i]['children'].push({
              key: `0## ~ ${element.estimateGroupId} ~ ${element.mContractId} ~ ${category.mCategoryCodeId}`,
              data: {
                type: 'header',
                description: 'Cost Type',
                takeoff: 'Description',
                cost: 'Cost',
                tileName: 'Tile Name',
              },
            })
          }
          keys.push({
            id: element.estimateGroupId,
            key: `0## ~ ${element.estimateGroupId} ~ ${element.mContractId} ~ ${category.mCategoryCodeId}`,
          })
        }
        if (category.costDetails && category.costDetails.length > 0) {
          category.costDetails.forEach((takeoff, j) => {
            treeData[index]['children'][i]['children'].push({
              key: `${element.estimateGroupId} ~ ${element.mContractId} ~ ${
                category.mCategoryCodeId
              } ~ ${takeoff.actualTakeoffId} ~ ${j} ~ ${JSON.stringify(
                takeoff,
              )}`,
              data: {
                description: takeoff.costType,
                takeoff: takeoff.takeoff,
                cost: takeoff.unitCost,
                tileName: takeoff.tileName,
              },
            })
            keys.push({
              id: element.estimateGroupId,
              key: `${element.estimateGroupId} ~ ${element.mContractId} ~ ${
                category.mCategoryCodeId
              } ~ ${takeoff.actualTakeoffId} ~ ${j} ~ ${JSON.stringify(
                takeoff,
              )}`,
            })
          })
        }
        if (category.lineItems && category.lineItems.length > 0) {
          category.lineItems.forEach((takeoff, j) => {
            treeData[index]['children'][i]['children'].push({
              key: `${element.estimateGroupId} ~ ${element.mContractId} ~ ${
                category.mCategoryCodeId
              } ~ ${takeoff.actualTakeoffId} ~ ${j} ~ ${JSON.stringify(
                takeoff,
              )}`,
              data: {
                description: takeoff.costType,
                takeoff: takeoff.takeoff,
                cost: takeoff.trendedCost,
                tileName: takeoff.estimateGroupName,
              },
            })
            keys.push({
              id: element.estimateGroupId,
              key: `${element.estimateGroupId} ~ ${element.mContractId} ~ ${
                category.mCategoryCodeId
              } ~ ${takeoff.actualTakeoffId} ~ ${j} ~ ${JSON.stringify(
                takeoff,
              )}`,
            })
          })
        }
      })
    }
  })

  if (list && list.length > 0) {
    list.forEach(element => {
      const details = keys.filter(i => i.id === element.id)
      if (details.length > 0) {
        Object.assign(treeKeys, {
          [element.id]: details.length,
        })
      }
    })
  }

  return { treeData: treeData, keyCount: keys, treeKeys: treeKeys }
}

export const highlightArchiveRow = (params, style) => {
  const rowStyle = { textAlign: 'left' }
  if (style) {
    rowStyle.textAlign = style
  }

  if (params.data && params.data.isArchive) {
    Object.assign(rowStyle, { backgroundColor: '#D3D3D3' })
  }

  return rowStyle
}
